export default "__VITE_ASSET__bZ8HH15O__"